<!doctype html>
<html lang="en">
  <head>
    <title>Print FBA</title>
  </head>
  <body id="pdf-data" #pdfContent style="width: 100%; max-width: 600px">
    <div class="pdf-content">
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"5%"}'>
          <img
            [src]="printData?.logo"
            alt="School Logo"
            data-pdfmake='{"width": 125, "fit": [125, 40]}' />
        </div>

        <div data-pdfmake='{"width":"*", "margin": [10, 0]}'>
          <div class="desc" style="text-align: right">
            {{ printData?.orgDetail.address }}
          </div>
          <div class="address" style="text-align: right">
            {{ printData?.orgDetail.city }}, {{ printData?.orgDetail.state }},
            {{ printData?.orgDetail.country }},
            {{ printData?.orgDetail.zipCode }}
          </div>
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div class="title" data-pdfmake='{"width":"*"}'>
          {{ printData?.caseDetail.student.firstName }}
          {{ printData?.caseDetail.student.lastName }}
        </div>
        <div style="width: auto"></div>
        <div
          class="title"
          style="text-align: right"
          data-pdfmake='{"width":"*"}'>
          <b>Supervisor : </b>
          {{ printData?.caseDetail.supervisorName || '-' }}
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Gender</div>
          <div class="dataValue">
            <b> {{ printData?.caseDetail.student.gender }}</b>
          </div>
        </div>
        <div style="width: auto">
          <div class="datalabel">Student School</div>
          <div class="dataValue">
            <b>{{ printData?.caseDetail.student.organizationName }}</b>
          </div>
        </div>
        <div style="text-align: left" data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Date Of Birth</div>
          <div class="dataValue">
            <b>{{
              printData?.caseDetail.student.dateOfBirth ?? null
                | date: 'MM/dd/yyyy'
            }}</b>
          </div>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":178}'>
          <div class="datalabel">Behavior Screener</div>
          <div class="dataValue">
            <b>{{ printData?.assesupdatedDate | date: 'MM/dd/yyyy' }}</b>
          </div>
        </div>
        <div data-pdfmake='{"width":"auto"}'>
          <div class="datalabel">Notes</div>
          <div class="dataValue">
            <b>{{ printData?.caseDetail.note || 'Nothing Entered' }}</b>
          </div>
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <div style="width: auto">
        <img
          [src]="printData?.chartImage"
          alt="Chart"
          style="width: 500px; height: auto"
          class="chartImage" />
        <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
        <div
          class="questionContainer"
          data-pdfmake='{"unbreakable": true, "margin": [0, 10, 0, 10]}'
          *ngFor="let que of printData?.behaviorAssessmentList; let i = index">
          <div class="questionHeader">
            <span class="stepIndicator">Question {{ i + 1 }}/16</span>
          </div>
          <b class="questionText">
            {{
              que.question
                | genderReplace
                  : printData?.caseDetail.student.firstName
                  : printData?.caseDetail.student.gender
            }}
          </b>
          <ul>
            <li
              *ngFor="let item of que.functionalAssessmentAnswers"
              [attr.data-pdfmake]="generateLI(item)"></li>
          </ul>
        </div>
      </div>
    </div>
  </body>
</html>
